const NEW_COLORS = {
  BASE: {
    WHITE: '#FFFFFF',
    BLACK: '#000000',
    OVERLAY: '#00000040',
  },
  PRIMARY: {
    25: '#F4F7FA',
    50: '#E6EEF8',
    100: '#CCDDF1',
    200: '#99BBE3',
    300: '#6698D4',
    400: '#3376C6',
    500: '#1539AA',
    600: '#004393',
    700: '#00326E',
    800: '#00224A',
    900: '#001125',
    950: '#00070F',
  },
  SECONDARY: {
    25: '#FFFBF5',
    50: '#FFF8ED',
    100: '#FEEFD6',
    200: '#FCDBAC',
    300: '#FAC177',
    400: '#F79C40',
    500: '#FF8800',
    600: '#E66410',
    700: '#BF4B0F',
    800: '#973C15',
    900: '#7A3314',
    950: '#421808',
  },

  GRAYSCALE: {
    25: '#FAFAFA',
    50: '#F2F2F2',
    100: '#E6E6E6',
    200: '#CCCCCC',
    300: '#B3B3B3',
    400: '#999999',
    500: '#7F7F7F',
    600: '#666666',
    700: '#4C4C4C',
    800: '#292929',
    900: '#141414',
    950: '#0F0F0F',
  },

  SEMANTICS: {
    SUCCESS: {
      25: '#F2F8F2',
      50: '#E9F3EA',
      100: '#D1E7D2',
      200: '#B6DAB7',
      300: '#96CD97',
      400: '#6DBE6F',
      500: '#24AE2A',
      600: '#219F26',
      700: '#1D8E22',
      800: '#197B1E',
      900: '#156518',
      950: '#0F4711',
    },

    ERROR: {
      25: '#F9F5F5',
      50: '#F7EDED',
      100: '#EFD1D1',
      200: '#DFA3A3',
      300: '#CE7575',
      400: '#BE4747',
      500: '#AE1919',
      600: '#8B1414',
      700: '#680F0F',
      800: '#460A0A',
      900: '#230505',
      950: '#120303',
    },

    WARNING: {
      25: '#FFF8F2',
      50: '#FFF3E9',
      100: '#FFEDD4',
      200: '#FFD8B6',
      300: '#FFC997',
      400: '#FFB96E',
      500: '#FFA726',
      600: '#E99923',
      700: '#D0881F',
      800: '#B4761B',
      900: '#936116',
      950: '#68440F',
    },

    INFO: {
      25: '#F3F9FE',
      50: '#EAF5FE',
      100: '#D3EBFC',
      200: '#BAE0FB',
      300: '#9CD5F9',
      400: '#76C9F8',
      500: '#3EBDF6',
      600: '#39ADE1',
      700: '#339AC9',
      800: '#2C86AE',
      900: '#246D8E',
      950: '#194D64',
    },
  },

  SUPPORT: {
    PINK: {
      25: '#FDF3F9',
      50: '#FCEBF5',
      100: '#F9D4EB',
      200: '#F7BBE0',
      300: '#F49ED5',
      400: '#F17AC9',
      500: '#EE46BC',
      600: '#D940AC',
      700: '#C23999',
      800: '#A83185',
      900: '#8A286D',
      950: '#611D4D',
    },

    PURPLE: {
      25: '#F5F4FE',
      50: '#EEECFE',
      100: '#DCD7FD',
      200: '#C8BFFC',
      300: '#B2A5FA',
      400: '#9884F9',
      500: '#7A5AF8',
      600: '#6F52E2',
      700: '#6449CA',
      800: '#6449CA',
      900: '#47348F',
      950: '#322565',
    },

    INDIGO: {
      25: '#F2F4FD',
      50: '#E9EDFC',
      100: '#D0DAFA',
      200: '#B5C5F7',
      300: '#94ADF4',
      400: '#6A92F2',
      500: '#1570EF',
      600: '#1366DA',
      700: '#115BC3',
      800: '#0F4FA9',
      900: '#0C418A',
      950: '#092E61',
    },
  },
} as const;

const CLASSIC_THEME = {
  CARD_BORDERS: NEW_COLORS.GRAYSCALE[600],
  LINE_DIVIDER: NEW_COLORS.GRAYSCALE[600],
};

const DARK_THEME = {
  CARD_BORDERS: NEW_COLORS.GRAYSCALE[600],
  LINE_DIVIDER: NEW_COLORS.GRAYSCALE[200],
};

export { CLASSIC_THEME, DARK_THEME, NEW_COLORS };
